export enum GetTicketTransactionsActionTypes {
    REQUEST = '@@ticket/get-ticket-transactions/request',
    SUCCESS = '@@ticket/get-ticket-transactions/success',
    ERROR = '@@ticket/get-ticket-transactions/error'
}

export enum GetLatestTicketTransactionsActionTypes {
    REQUEST = '@@ticket/get-latest-ticket-transactions/request',
    SUCCESS = '@@ticket/get-latest-ticket-transactions/success',
    ERROR = '@@ticket/get-latest-ticket-transactions/error'
}
